export const IMPORT_ALLOWED_EXTENSIONS = ['.csv', '.xls', '.xlsx'];
export const IMPORT_MAX_FILE_BYTES = 5 * 1024 * 1024;

export const hasValidationErrors = (errors) =>
  Object.values(errors || {}).some((value) => Boolean(value));

export const validateImportFile = (file) => {
  const errors = {};
  if (!file) {
    errors.file = 'File wajib dipilih.';
    return errors;
  }
  const name = file.name || '';
  const ext = name.toLowerCase().slice(name.lastIndexOf('.'));
  if (!IMPORT_ALLOWED_EXTENSIONS.includes(ext)) {
    errors.file = 'Format harus CSV, XLS, atau XLSX.';
  }
  if (file.size > IMPORT_MAX_FILE_BYTES) {
    errors.file = 'Ukuran file maksimal 5 MB.';
  }
  return errors;
};

export const validateCentralForm = ({ username, fullName, password, role }, { isEdit = false } = {}) => {
  const errors = {};
  if (!username?.trim()) errors.username = 'Username wajib diisi.';
  if (!fullName?.trim()) errors.fullName = 'Nama lengkap wajib diisi.';
  if (!isEdit && !password?.trim()) errors.password = 'Password wajib diisi.';
  if (password?.trim() && password.trim().length < 6) {
    errors.password = 'Password minimal 6 karakter.';
  }
  if (!role) errors.role = 'Role wajib dipilih.';
  return errors;
};

export const validateHospitalForm = (
  { username, namaLengkap, email, idGroups, password },
  { isEdit = false } = {}
) => {
  const errors = {};
  if (!username?.trim()) errors.username = 'Username wajib diisi.';
  if (!namaLengkap?.trim()) errors.namaLengkap = 'Nama lengkap wajib diisi.';
  if (!email?.trim()) errors.email = 'Email wajib diisi.';
  if (!idGroups) errors.idGroups = 'Role wajib dipilih.';
  if (!isEdit && !password?.trim()) errors.password = 'Password wajib diisi.';
  if (password?.trim() && password.trim().length < 6) {
    errors.password = 'Password minimal 6 karakter.';
  }
  return errors;
};
